module.exports = __webpack_public_path__ + "static/img/global_app_access_img_3.4ac6c9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/global_app_access_img_3.jpg
// module id = PKyx
// module chunks = 0